import LoadingScreen from './loading_screen';

export default LoadingScreen;
